import { render, staticRenderFns } from "./DeviceInfo.vue?vue&type=template&id=f2b032d4&"
import script from "./DeviceInfo.vue?vue&type=script&lang=js&"
export * from "./DeviceInfo.vue?vue&type=script&lang=js&"
import style0 from "./DeviceInfo.vue?vue&type=style&index=0&id=f2b032d4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QIcon,QTooltip,QSelect} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QIcon,QTooltip,QSelect})
